/**
 * Static option lists for the customer list Filters (Industry / Source). Values
 * are lifted verbatim from the DataCentral v4 `modules/Customer/constants` so
 * the base64 `filters` payload the backend decodes matches the legacy client.
 * Labels are the short EN heads (the legacy labels carry a VN gloss in parens).
 * Async employee / product-group selects are deferred to Phase 2.
 */
import type { FilterOption } from '@vnetwork/ui/data';

/** Customer industry slugs (`customer_industry`). */
export const INDUSTRY_OPTIONS: FilterOption[] = [
  { value: 'ecomerce', label: 'Ecommerce' },
  { value: 'education', label: 'Education' },
  { value: 'fintech', label: 'Fintech' },
  { value: 'cryptocurrentcy', label: 'Cryptocurrency' },
  { value: 'logistics', label: 'Logistics & Transport' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'services', label: 'Services' },
  { value: 'multimedia', label: 'Multimedia' },
  { value: 'technology', label: 'Technology' },
  { value: 'game', label: 'Game' },
  { value: 'real-estate', label: 'Real Estate' },
  { value: 'retail', label: 'Retail' },
  { value: 'energy', label: 'Energy' },
  { value: 'agriculture', label: 'Agriculture' },
  { value: 'construction', label: 'Construction' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'securities', label: 'Securities' },
  { value: 'airlines', label: 'Airlines' },
  { value: 'bank', label: 'Bank' },
  { value: 'telecom', label: 'Telecom' },
  { value: 'goverment', label: 'Government' },
  { value: 'automotive', label: 'Automotive' },
  { value: 'media-entertainment', label: 'Media & Entertainment' },
  { value: 'food-beverage', label: 'F&B' },
  { value: 'fashion', label: 'Fashion & Beauty' },
  { value: 'hr-recruitment', label: 'HR & Recruitment' },
  { value: 'legal', label: 'Legal' },
  { value: 'accounting-audit', label: 'Accounting & Audit' },
  { value: 'ngo', label: 'NGO' },
  { value: 'defense', label: 'Defense & Security' },
  { value: 'sports-fitness', label: 'Sports & Fitness' },
  { value: 'pet', label: 'Pet & Veterinary' },
  { value: 'environment', label: 'Environment' },
  { value: 'printing-packaging', label: 'Printing & Packaging' },
  { value: 'others', label: 'Others' },
];

/** Customer acquisition source slugs (`customer_source`). */
export const SOURCE_OPTIONS: FilterOption[] = [
  { value: 'form', label: 'Forms' },
  { value: 'event', label: 'Event' },
  { value: 'livechat', label: 'Live chat' },
  { value: 'hotline', label: 'Hotline' },
  { value: 'email', label: 'Email' },
  { value: 'gg_ads', label: 'Google Ads' },
  { value: 'fb_ads', label: 'Facebook Ads' },
  { value: 'marketing_approach', label: 'Marketing approach (old)' },
  { value: 'research', label: 'Research' },
  { value: 'contact', label: 'Contact' },
  { value: 'sale_event', label: 'Sale event' },
];
